module.exports = __webpack_public_path__ + "static/media/Pod_Sv_kopeckemII.085a594c.md";